import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

import { BbookingStepsType, IStyleProps, VisaulGuideStepItemType } from '../../types';
import StepItem from '../StepItem';
import { StepsWrapper } from './styled';

interface IProps {
	bookingSteps: BbookingStepsType;
	visualGuideSteps: VisaulGuideStepItemType[];
	styleProps?: IStyleProps;
}

function StepSection({ bookingSteps, visualGuideSteps, styleProps }: IProps) {
	const { t } = useTranslation();
	return (
		<Grid display="flex" flexDirection="column" gap="24px">
			<MediaTypography variant="h4" color={styleProps.titlesColor}>
				{t(bookingSteps.bookingSteps)}
			</MediaTypography>

			<StepsWrapper>
				{visualGuideSteps.map(({ title, imageSrc, altImageName }, index) => (
					<StepItem
						key={index}
						step={index}
						title={title}
						imageSrc={imageSrc}
						altImageName={altImageName}
						styleProps={styleProps}
					/>
				))}
			</StepsWrapper>
		</Grid>
	);
}

export default StepSection;
